module.exports = __webpack_public_path__ + "static/media/CoverPage-yuma-parttwo.f95762bd.png";